export function initialState() {
  return {
    showSidebar: false,
    referrer: ''
  }
}

export default initialState()
